import(/* webpackMode: "eager" */ "/usr/app/src/app/[locale]/(profile)/profile/page.tsx");
